import React from 'react';
import { Input, Tooltip } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useViewerStore } from '@store/viewerModule/base';
import { useDispatch, useSelector } from 'react-redux';
import { createTempDashboard, removeKey } from '@store/tempDashboard/actions';
import {
  DASHBOARD_TYPE,
  INTERNAL_UNKNOWN,
  INTERNAL_UNKNOWN_TOOLTIP,
  UNKNOWN,
  UNKNOWN_TOOLTIP,
} from '@utils/constants';
import {
  getViewerModuleTempDashboardUrl,
  getViewerModuleNewTabUrl,
} from '@components/common/Dashboard/utils/getTempDashboardUrl';
import { viewersBrowserTabFeatureSelector } from '@store/common/selectors';
import { SearchWrapper, Title } from './styled';
import { QuestionCircleOutlined } from '@ant-design/icons';

const { Search } = Input;

function SearchBar() {
  const navigate = useNavigate();
  const [{ viewerId }] = useViewerStore();
  const dispatch = useDispatch();
  const { id }: any = useParams();

  const vmBrowserTabEnabled = useSelector(viewersBrowserTabFeatureSelector);

  const handleSearch = (value) => {
    if (value) {
      // new browser tab
      if (vmBrowserTabEnabled) {
        const url = getViewerModuleNewTabUrl(value);
        window.open(`${url}`, '_blank', 'noopener,noreferrer');
      } else {
        // new p5 tab
        // callback to push new temp tab url
        const redirectHandler = ({ id }) => {
          navigate(getViewerModuleTempDashboardUrl(value, id));
        };

        // if on a temp tab, remove current one
        if (id) {
          dispatch(removeKey(id));
        }

        // create local storage entry
        dispatch(
          createTempDashboard(
            DASHBOARD_TYPE.VIEWER_MODULE,
            { viewerId: value },
            `Viewer ${value}`.substr(0, 20),
            { redirectHandler },
          ),
        );
      }
    }
  };

  const title = (
    <>
      <div>{`${INTERNAL_UNKNOWN} = ${INTERNAL_UNKNOWN_TOOLTIP}`}</div>
      <div>{`${UNKNOWN} = ${UNKNOWN_TOOLTIP}`}</div>
    </>
  );

  return (
    <SearchWrapper>
      <Title>Viewer ID or Public IP Address</Title>
      <div>
        <Search
          placeholder="Enter a Viewer ID or Public IP Address"
          allowClear
          onSearch={handleSearch}
          style={{ width: 350 }}
          defaultValue={viewerId || ''}
        />
      </div>
      <Tooltip title={title}>
        <QuestionCircleOutlined style={{ marginLeft: '6px' }} />
      </Tooltip>
    </SearchWrapper>
  );
}

export default SearchBar;
